import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_project-hub-632/artifacts/0k2lfbqe_deepthree%20studio.png";

export const Logo = ({ size = "md", className = "", testId = "brand-logo" }) => {
  // Reserve a generous box; logo PNG has lots of padding around glyphs.
  const dims = size === "lg" ? "h-20 w-40" : size === "sm" ? "h-9 w-20" : "h-12 w-28";
  return (
    <div data-testid={testId} className={`flex items-center ${className}`}>
      <img
        src={LOGO_URL}
        alt="Deepthree Studio"
        className={`${dims} object-contain object-left select-none`}
        draggable={false}
      />
    </div>
  );
};

export default Logo;
